import { EntityModel } from '@/interfaces'
import {
  ALL_NEWSLETTER_PROVIDERS_QUERY,
  CREATE_NEWSLETTER_PROVIDER_MUTATION,
  DELETE_NEWSLETTER_PROVIDER_MUTATION,
  FORCE_DELETE_NEWSLETTER_PROVIDER_MUTATION,
  SINGLE_NEWSLETTER_PROVIDER_QUERY,
  UPDATE_NEWSLETTER_PROVIDER_MUTATION,
} from './graphql'
import mailchimpConfigEntity from '@/entities/mailchimpConfig/entity'

const newsletterProviderModel: EntityModel = {
  name: 'newsletterProvider',
  namePlural: 'newsletterProviders',
  uniqueName: 'newsletterProvider',
  uniqueNamePlural: 'newsletterProviders',
  path: 'config/tenant/newsletter_provider',
  baseUrl: '/config/tenant/newsletter_providers',
  translationPrefix: 'entities:newsletterProvider.',
  getDisplayName: (values: any) => {
    return 'NEWSLETTER PROVIDER'
  },
  gql: {
    getAll: ALL_NEWSLETTER_PROVIDERS_QUERY,
    getSingle: SINGLE_NEWSLETTER_PROVIDER_QUERY,
    create: CREATE_NEWSLETTER_PROVIDER_MUTATION,
    update: UPDATE_NEWSLETTER_PROVIDER_MUTATION,
    delete: DELETE_NEWSLETTER_PROVIDER_MUTATION,
    forceDelete: FORCE_DELETE_NEWSLETTER_PROVIDER_MUTATION,
  },
  attributes: {
    provider: {
      name: 'provider',
      label: 'entities:newsletterProvider.attributes.provider.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'MAILCHIMP',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:newsletterProvider.attributes.provider.selectOptions.MAILCHIMP.label',
          value: 'MAILCHIMP',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    config: {
      name: 'config',
      label: 'entities:newsletterProvider.attributes.config.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mailchimpConfigEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default newsletterProviderModel
